module.exports = __webpack_public_path__ + "img/team2_0.bc7c36f9.jpg";